import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { applySEO } from "../seo/applySEO";
import { getRouteSEO } from "../seo/seoConfig";

const SEO = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const lang = i18n.language === "ar" ? "ar" : "en";

  useEffect(() => {
    const config = getRouteSEO(location.pathname, lang);
    if (!config) return;

    applySEO({
      ...config,
      path: location.pathname,
      lang,
    });
  }, [location.pathname, lang]);

  return null;
};

export default SEO;
